(function () {
    const themeSettings = window.theme ? window.theme.settings : null;

    // Exit if auto-clear is disabled or settings are missing
    if (!themeSettings || !themeSettings.autoClearCartEnabled) {
        return;
    }

    const inactivityHours = themeSettings.autoClearCartTime || 12;
    const inactivityMs = inactivityHours * 60 * 60 * 1000;
    const now = Date.now();
    const lastActivityKey = 'endurpro_cart_last_activity';
    const lastActivity = localStorage.getItem(lastActivityKey);

    /**
     * Clears the Shopify cart using the AJAX API.
     */
    async function clearCart() {
        console.log('Cart inactivity threshold reached. Clearing cart...');

        const clearUrl = (window.theme.routes && window.theme.routes.root)
            ? window.theme.routes.root + 'cart/clear.js'
            : '/cart/clear.js';

        try {
            const response = await fetch(clearUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            const data = await response.json();
            console.log('Cart has been cleared successfully.');

            // Reset subtotal in global theme object
            if (window.theme) {
                window.theme.subtotal = 0;
            }

            // Update activity timestamp to now
            localStorage.setItem(lastActivityKey, Date.now().toString());

            // Notify theme components to refresh UI
            document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));

            // If on the cart page, reload to show empty state
            if (window.location.pathname.includes('/cart')) {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error clearing cart:', error);
        }
    }

    // Check if we should clear the cart on page load
    if (lastActivity) {
        const elapsed = now - parseInt(lastActivity);

        // Only clear if elapsed time exceeds threshold AND there are items in the cart
        if (elapsed > inactivityMs && window.theme.subtotal > 0) {
            console.log("Clearing cart due to inactivity.");
            clearCart();
        }
    }

    // Update last activity timestamp on current load
    localStorage.setItem(lastActivityKey, now.toString());

    /**
     * Throttle function to limit execution frequency
     */
    function throttle(func, limit) {
        let inThrottle;
        return function () {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => inThrottle = false, limit);
            }
        }
    }

    // Update activity timestamp on user interactions to be more precise
    const updateActivity = throttle(() => {
        localStorage.setItem(lastActivityKey, Date.now().toString());
    }, 30000); // Only update every 30 seconds max during active use

    const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    activityEvents.forEach(event => {
        window.addEventListener(event, updateActivity, { passive: true });
    });

    // Prevent cart drawer from auto-opening after clearing the cart
    if (window.theme && window.theme.subtotal === 0) {
        console.log("Cart is empty. Preventing drawer from opening.");
        const cartDrawer = document.querySelector('#shopify-section-cart-drawer');
        if (cartDrawer) {
            cartDrawer.classList.add('cart-empty'); // Add a class indicating the cart is empty
            cartDrawer.querySelector('.cart-drawer').style.display = 'none'; // Hide the drawer if empty
        }
    }

    // Delay the opening of the cart drawer by 5 seconds (only if there are items in the cart)
    setTimeout(() => {
        console.log("5-second timeout reached. Checking if cart has items...");

        if (window.theme && window.theme.subtotal > 0) {
            console.log("Opening cart drawer...");
            const cartDrawer = document.querySelector('#shopify-section-cart-drawer');
            if (cartDrawer) {
                const drawerElement = cartDrawer.querySelector('.cart-drawer');
                if (drawerElement) {
                    drawerElement.style.display = 'block'; // Show the drawer after 5 seconds
                    console.log("Cart drawer opened.");
                } else {
                    console.log("Cart drawer element not found.");
                }
            } else {
                console.log("Cart drawer not found.");
            }
        } else {
            console.log("Cart is empty, drawer will not open.");
        }
    }, 5000); // 5000ms = 5 seconds delay

})();
